import { VOTING_LAYOUT, VotingLayoutKey, VotingOption } from "../Helpers/VotingSectionHelpers";
import { VotingCheckboxLabelsOptions } from "./VotingCheckboxLabelsOptions";
import { VotingImageCardsOptions } from "./VotingImageCardsOptions";
import { VotingPoolButtonsOptions } from "./VotingPoolButtonsOptions";
import { VotingRadioButtonsOptions } from "./VotingRadioButtonsOptions";

type VotingOptionsProps = {
  layout: VotingLayoutKey | string;
  options: VotingOption[];
  selectedOptionIds: string[];
  onToggleOption: (optionId: string) => void;
  onSelectOption: (optionId: string) => void;
  sectionId: string;
  votingOptionsTitle?: string;
  pollCounts?: Record<string, number>;
};

export const VotingOptions = ({
  layout,
  options,
  selectedOptionIds,
  onToggleOption,
  onSelectOption,
  sectionId,
  votingOptionsTitle,
  pollCounts = {},
}: VotingOptionsProps) => {
  switch (layout) {
    case VOTING_LAYOUT.IMAGE_CARDS:
      return (
        <VotingImageCardsOptions
          options={options}
          selectedOptionIds={selectedOptionIds}
          onToggleOption={onToggleOption}
          sectionId={sectionId}
        />
      );
    case VOTING_LAYOUT.CHECKBOX_LABELS:
      return (
        <VotingCheckboxLabelsOptions
          options={options}
          selectedOptionIds={selectedOptionIds}
          onToggleOption={onToggleOption}
          sectionId={sectionId}
        />
      );
    case VOTING_LAYOUT.RADIO_BUTTONS:
      return (
        <VotingRadioButtonsOptions
          options={options}
          selectedOptionIds={selectedOptionIds}
          onSelectOption={onSelectOption}
          sectionId={sectionId}
          votingOptionsTitle={votingOptionsTitle}
        />
      );
    case VOTING_LAYOUT.POOL_BUTTONS:
      return (
        <VotingPoolButtonsOptions
          options={options}
          selectedOptionIds={selectedOptionIds}
          onToggleOption={onToggleOption}
          pollCounts={pollCounts}
        />
      );
    default:
      return null;
  }
};
